<template>
    <Question :question="question">
        <div class="form-group">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">Email</span>
                </div>
                <input type="email" pattern="(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)" class="form-control" v-model="email" required>
            </div>
            <br>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">Home Phone</span>
                </div>
                <input type="input"
                    pattern="([0-9]{10}|[0-9]{3}-[0-9]{3}-[0-9]{4})" 
                    class="form-control"  v-model="phoneNumber" 
                    placeholder="XXX-XXX-XXXX"
                    required>
                </div>
            </div>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">Cell Phone</span>
                </div>
                <input type="input" pattern="([0-9]{10}|[0-9]{3}-[0-9]{3}-[0-9]{4})" class="form-control" 
                            placeholder="XXX-XXX-XXXX" v-model="cellPhoneNumber" required>
            </div>
    </Question>
</template>

<script>
import Question from '../Question.vue'


export default {
  name: 'Email',
  props: {
      question: String
  },
  components: {
      Question
  },
  data: function() {
      return {
          "email": "",
          "cellPhoneNumber" : "", 
          "phoneNumber" : ""
      };
  }
}
</script>